export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService'
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this.api = ApiService.api;
		this.errors = ApiService.errors;
		this.successes = ApiService.successes;

		this.$q = $q;
		this.$http = $http;
		this.$cookies = $cookies;

	}

	//a.res(href="https://en.wikipedia.org/wiki/Snake_case", target="_blank") Snake Case.

	get service(){
		return {

			deletePicture: {
				name: 'deletePicture',
				humanName: 'Delete Saved Picture',
				description: 'Delete saved picture by id',
				request: {
					type: 'DELETE',
					route: '/personal/panels/:mac/pictures/:pictureId',
					params: [
						{ name: 'mac', type: 'String', description: 'MAC Address' },
						{ name: 'pictureId', type: 'Integer', description: 'Picture id' }
					],
					param: []
				},
				response: {
					success: {
						data: [
							{ name: 'status', type: 'String', description: 'MAC Address' }
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/panels/' + param[0] + '/pictures/' + param[1],
						method: 'DELETE',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			getPicturesAlarm: {
				name: 'getPictures',
				humanName: 'Get Pictures',
				description: 'Get list of pictures by MAC address with paging capabilities, route accepts query params for paging',
				request: {
					type: 'GET',
					route: '/personal/panels/:mac/pictures/:type',
					params: [
						{ name: 'mac', type: 'String', description: 'MAC Address' },
						{
							name: 'type',
							type: 'String',
							description: 'Optional param, could be saved/alarm (Omitting this param will return both types)'
						},
						{ name: '', type: 'Query params', description: 'skip: INT, limit: INT, order: DESC or ASC' }
					],
					param: ['0013A102184B', 'alarm', '?skip=10&limit=5&order=DESC']
				},
				response: {
					success: {
						data: [
							{ name: 'Array (JSON)', type: 'Array', description: 'Pictures array' }
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/panels/' + param[0] + '/pictures/' + param[1] + '' + param[2],
						method: 'GET',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			getReports: {
				name: 'getReports',
				humanName: 'Get Reports (Events)',
				description: 'Route accepts query params for paging',
				request: {
					type: 'GET',
					route: '/personal/panels/:mac/reports',
					params: [
						{ name: 'mac', type: 'String', description: 'MAC Address' },
						{ name: '', type: 'Query params', description: 'skip: INT, limit: INT, order: DESC or ASC' }
					],
					param: ['0013A102184B', '?skip=10&limit=5&order=DESC']
				},
				response: {
					success: {
						data: [
							{ name: 'Array (JSON)', type: 'Array', description: 'Reports array' }
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/panels/' + param[0] + '/reports' + param[1],
						method: 'GET',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			}


		}
	}

}



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/api.service.personal.items.js
 **/